<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div aria-label="Carregando estimativa do imóvel" class="grid gap-4">
    <span class="sr-only">Carregando histórico de condomínio</span>
    <div
      class="rounded-lais border border-lais-border bg-white p-5 shadow-lais-card animate-pulse"
    >
      <div class="h-4 w-48 rounded bg-lais-bg-muted" />
      <div class="mt-3 h-7 w-2/3 rounded bg-lais-bg-muted" />
      <div class="mt-3 h-4 w-4/5 rounded bg-lais-bg-muted" />
      <div class="mt-4 grid gap-2 sm:grid-cols-4">
        <div
          v-for="index in 4"
          :key="`detail-card-${index}`"
          class="h-16 rounded-lais-sm bg-lais-bg-muted"
        />
      </div>
    </div>
    <div
      class="rounded-lais border border-lais-border bg-white p-5 shadow-lais-card animate-pulse"
    >
      <div class="h-4 w-40 rounded bg-lais-bg-muted" />
      <div class="mt-8 h-3 rounded-full bg-lais-bg-muted" />
      <div class="mt-5 grid gap-2 sm:grid-cols-3">
        <div
          v-for="index in 3"
          :key="`detail-ruler-${index}`"
          class="h-16 rounded-lais-sm bg-lais-bg-muted"
        />
      </div>
    </div>
    <div class="grid gap-3 lg:grid-cols-3">
      <div
        v-for="index in 3"
        :key="`detail-list-${index}`"
        class="h-28 rounded-lais border border-lais-border bg-white shadow-lais-card animate-pulse"
      />
    </div>
  </div>
</template>
